(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-pledge_accordion_text"] && !Shopify.designMode) return;
  try {
    
  const expanderWrapper = document.getElementById('business-ethics-expand');
  let expanderItems = expanderWrapper.querySelectorAll('.choice-expander');

  expanderItems.forEach((expanderItem) => {
    expanderItem.addEventListener('click', () => {
      expanderItem.classList.toggle("active");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
